export const TaxFilingRetirementContent = {
  pageTitle: 'Just a few more questions',
  pageSubtitle: "We're asking these so we can suggest personalized guidance.",
};
